import { render, staticRenderFns } from "./board-column.vue?vue&type=template&id=76740126&"
import script from "./board-column.vue?vue&type=script&lang=js&"
export * from "./board-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports